var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-form-item",
    {
      staticClass: "ik-form-popup-item",
      attrs: { label: _vm.name, required: _vm.getRequire },
    },
    [
      _c("el-input", {
        class: { require: _vm.getRequire && _vm.isNull(), item: true },
        attrs: {
          type: "text",
          size: "small",
          disabled: _vm.disabled,
          "show-word-limit": "",
          clearable: true,
        },
        on: { focus: _vm.togglePopover, input: _vm.input },
        model: {
          value: _vm.val,
          callback: function ($$v) {
            _vm.val = $$v
          },
          expression: "val",
        },
      }),
      _c(
        "el-popover",
        {
          staticClass: "ik-el-popover-warp",
          attrs: {
            placement: "bottom",
            width: "550",
            trigger: "manual",
            "append-to-body": true,
            "popper-class": "ik-data-popup-popper",
          },
          model: {
            value: _vm.visible,
            callback: function ($$v) {
              _vm.visible = $$v
            },
            expression: "visible",
          },
        },
        [
          _c(
            "span",
            {
              staticClass: "svg-container ik-list-icon-pop",
              on: { click: _vm.closepop },
            },
            [_c("svg-icon", { attrs: { "icon-class": "close" } })],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: { data: _vm.tableData },
              on: { "row-click": _vm.rowClick },
            },
            _vm._l(_vm.filedList, function (item, index) {
              return _c("el-table-column", {
                key: index,
                attrs: { property: item.code, label: item.name },
              })
            }),
            1
          ),
          _c("el-pagination", {
            attrs: {
              layout: "total, prev, pager, next",
              "page-count": _vm.pagination.pageCount,
              "page-size": _vm.pagination.pageSize,
              total: _vm.pagination.totalCount,
            },
            on: {
              "current-change": _vm.currentChange,
              "prev-click": _vm.prevClick,
              "next-click": _vm.nextClick,
            },
          }),
        ],
        1
      ),
      _vm.errorSign
        ? _c(
            "el-tooltip",
            {
              staticClass: "right",
              attrs: { effect: "dark", content: _vm.message, placement: "top" },
            },
            [
              _c("div", [
                _c("i", {
                  staticClass: "el-icon-warning",
                  staticStyle: { color: "red" },
                }),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }